var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2927 10.3442L9.7037 5.75825C9.51329 5.58609 9.26397 5.49374 9.00736 5.50033C8.75075 5.50692 8.50649 5.61194 8.32517 5.79365C8.14385 5.97535 8.03935 6.21983 8.03331 6.47645C8.02726 6.73308 8.12014 6.98221 8.2927 7.17225L12.8787 11.7582C13.0662 11.9458 13.1715 12.2001 13.1715 12.4652C13.1715 12.7304 13.0662 12.9847 12.8787 13.1722L8.2927 17.7582C8.19986 17.8512 8.12622 17.9614 8.076 18.0828C8.02578 18.2042 7.99995 18.3343 8 18.4656C8.00005 18.5969 8.02596 18.727 8.07627 18.8483C8.12658 18.9697 8.20029 19.0799 8.2932 19.1727C8.38611 19.2656 8.4964 19.3392 8.61777 19.3894C8.73914 19.4397 8.86921 19.4655 9.00056 19.4654C9.1319 19.4654 9.26196 19.4395 9.38329 19.3892C9.50462 19.3389 9.61486 19.2652 9.7077 19.1722L14.2927 14.5862C14.8551 14.0237 15.1711 13.2607 15.1711 12.4652C15.1711 11.6698 14.8551 10.9068 14.2927 10.3442Z",
    fill: "#696969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.9e3896e228b34c9601b402f520d60e31.svg";
export { ForwardRef as ReactComponent };